import React from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

import { Chip } from "@mui/material";

import DataTable from "../../../common/DataTable";
import ColumnHeader from "../../../common/ColumnHeader";
import { getChipColor } from "../../../../constants/value";
import { dateSortComparator } from "../../../../utils/date";

const TmobilejFilterGroupAssignList = ({
  data,
  meta,
  client,
  loading,
  disableRowClick,
  handlePageChange,
  handleColumnClick,
  handlePageSizeChange,
  ...props
}) => {
  const nav = useNavigate();
  const handleRowClick = (e) => {
    nav(`/tmobilej/filter_group_assign/${e.row.id}`);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 1, sortable: false },
    {
      field: "msisdn",
      headerName: "MSISDN",
      minWidth: 120,
      flex: 2,
      sortable: false,
      renderHeader: () =>
        client ? (
          <ColumnHeader
            label="MSISDN"
            handleClick={() => handleColumnClick("msisdn")}
          />
        ) : (
          "MSISDN"
        ),
    },
    {
      field: "subscriber_id",
      headerName: "Subscriber ID",
      minWidth: 170,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.subscriber_id || "-",
    },
    {
      field: "filter_type",
      headerName: "Filter Type",
      minWidth: 120,
      flex: 2,
      sortable: false,
    },
    {
      field: "selected_group_names",
      headerName: "Group Names",
      minWidth: 220,
      flex: 3,
      sortable: false,
      valueGetter: (params) => (params.row.selected_group_names || []).join(", "),
    },
    {
      field: "selected_group_ids",
      headerName: "Group IDs",
      minWidth: 180,
      flex: 3,
      sortable: false,
      valueGetter: (params) => (params.row.selected_group_ids || []).join(", "),
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 120,
      flex: 2,
      renderCell: (params) => (
        <Chip
          label={params.row.status}
          size="small"
          color={getChipColor(params.row.status)}
        />
      ),
      sortable: false,
    },
    {
      field: "batch_id",
      headerName: "Batch ID",
      minWidth: 150,
      flex: 2,
      sortable: false,
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.created_at || null,
      valueFormatter: (params) =>
        params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.last_updated || null,
      valueFormatter: (params) =>
        params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
  ];

  return (
    <DataTable
      disableColumnFilter
      loading={loading}
      data={data}
      columns={client ? columns.map((v) => ({ ...v, sortable: true })) : columns}
      metaData={meta}
      handleRowClick={disableRowClick ? null : handleRowClick}
      handlePageChange={handlePageChange}
      handlePageSizeChange={handlePageSizeChange}
      filterMode={client ? "client" : "server"}
      client={client}
      {...props}
    />
  );
};

export default TmobilejFilterGroupAssignList;
